import type { useFloating, useInteractions } from '@floating-ui/react';
import classNames from 'clsx';
import React from 'react';

import styles from './CardTitle.scss';

interface Props {
  refs?: ReturnType<typeof useFloating>['refs'];
  getReferenceProps?: ReturnType<typeof useInteractions>['getReferenceProps'];
  className?: string;
  isDropdown?: true;
}

const CardTitle: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  refs,
  getReferenceProps,
  className,
  isDropdown
}) => (
  <h1
    className={classNames(styles.cardTitle, className, {
      [styles.dropdown]: isDropdown
    })}
    ref={refs?.setReference}
    {...getReferenceProps?.()}
  >
    {children}
  </h1>
);

export { CardTitle };
